import { useRoleLayout } from "../hooks/useRoleLayout";
const SubUserPasswordReset = () => {
     const { Layout: RoleLayout } = useRoleLayout();
  return (
    <div>SubUserPasswordReset</div>
  )
}

export default SubUserPasswordReset